import { render, staticRenderFns } from "./MethodsOfPayment.vue?vue&type=template&id=aa7486b0"
import script from "./MethodsOfPayment.vue?vue&type=script&lang=ts"
export * from "./MethodsOfPayment.vue?vue&type=script&lang=ts"
import style0 from "./MethodsOfPayment.vue?vue&type=style&index=0&id=aa7486b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports